/* eslint-disable padding-line-between-statements */
/* eslint-disable camelcase */
/* eslint-disable no-secrets/no-secrets */
/* eslint-disable no-undef */
/* eslint-disable @typescript-eslint/no-unused-vars */

import React, { useCallback, useState, useContext, useEffect } from 'react';
import { useDataRefresh, ViewModelForm, ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { BreakpointTrackerContext } from '@jutro/layout';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { useDependencies } from '@xengage/gw-portals-dependency-react';
import wizardStyles from 'twia-portals-wizard-components-ui/common/TWIAWizard.module.scss'
import { TranslatorContext } from '@jutro/locale';
import { Icon } from '@jutro/components';
import _ from 'lodash';
import metadata from './TWIACPConstructionDetails.metadata.json5';
import styles from './TWIACPConstructionDetails.module.scss';
import messages from './TWIACPConstructionDetails.messages';
import TWIACPBuildingLocationsHelper from '../../util/TWIACPBuildingLocationsHelper';

function TWIACPConstructionDetails(props) {
    const breakpoint = useContext(BreakpointTrackerContext);
    const { submissionVM, updateWizardData, id, selectedBuilding, updateSubmissionData, address,
        showErrorsConstruction, findInvalidComponent, onValidate } = props;
    const [buildingViewVM, updateBuildingViewVM] = useState(selectedBuilding);
    const viewModelService = useContext(ViewModelServiceContext);
    const { refreshData } = useDataRefresh();
    const [isTotalAreaEditable, setIsTotalAreaEditable] = useState()
    const [showErrors, updateShowErrors] = useState(false);
    const { isComponentValid, onValidate: setComponentValidation } = useValidation(id);
    const [yearMismatchValidationMessage, setYearMismatchValidationMessage] = useState([]);
    const [dateMismatchValidationMessage, setDateMismatchValidationMessage] = useState([]);
    const [futureYearValidationMessage, setFutureYearValidationMessage] = useState([]);
    const yearBuilt = _.get(buildingViewVM, 'construction_TWIA.yearBuilt_TWIA.value');
    const translator = useContext(TranslatorContext);
    const jobType = _.get(submissionVM, 'baseData.jobType.value')?.code;

    useEffect(() => {
        setIsTotalAreaEditable(!_.get(selectedBuilding, 'construction_TWIA.areaOfExistingStructure_TWIA.aspects.visible') ||
            !_.get(selectedBuilding, 'construction_TWIA.areaOfAddition_TWIA.aspects.visible'))
        // DE15761 DE15762
        if (selectedBuilding.construction_TWIA.buildersRiskForm_Validation_TWIA !== undefined) {
            _.set(selectedBuilding, 'construction_TWIA.buildersRiskForm_Validation_TWIA.value', selectedBuilding.buildersRiskForm_TWIA.value);
        }        
        updateBuildingViewVM(selectedBuilding)
        refreshData();
    }, [])

    useEffect(() => {
        const totalArea = _.get(buildingViewVM, 'construction_TWIA.totalArea_TWIA.value')
        if(totalArea < 20000) {
            _.set(buildingViewVM, 'construction_TWIA.groundFloorArea_TWIA', null)
            handleModelChange(buildingViewVM)
        }
    }, []); // DE18407

    const constructionChange = (value, path) => {
        _.set(buildingViewVM, `${path}.value`, value)
        _.set(buildingViewVM, 'construction_TWIA.groundFloorArea_TWIA', null)
        handleModelChange(buildingViewVM)
    }

    const handleModelChange = useCallback(
        newModel => {
            updateBuildingViewVM(newModel);
            refreshData();
        },
        [refreshData]
    );


    const isRiskLocationCountyHarris_TWIA = useCallback(() => {
        const displayCounty = 'Harris';
        const currentLocationCounty = submissionVM.lobData.commercialProperty.coverables.locations.value[0].address.county;

        return (!_.isNil(currentLocationCounty)) ? currentLocationCounty.toLowerCase() === displayCounty.toLowerCase() : false;
    }, [submissionVM]);


    useEffect(() => {

        if (_.get(buildingViewVM, 'construction_TWIA.areaOfExistingStructure_TWIA') ||
            _.get(buildingViewVM, 'construction_TWIA.areaOfAddition_TWIA')) {
            setIsTotalAreaEditable(!_.get(buildingViewVM, 'construction_TWIA.areaOfExistingStructure_TWIA.aspects.visible') ||
                !_.get(buildingViewVM, 'construction_TWIA.areaOfAddition_TWIA.aspects.visible'))
        }

    }, [buildingViewVM ])

    useEffect(() => {
        if (onValidate && !_.isNull(isComponentValid)) {
            onValidate(isComponentValid, id);
        }
    }, [isComponentValid, onValidate]);

    useEffect(() => {
        findInvalidComponent(isComponentValid, id);
    }, [findInvalidComponent, isComponentValid])


    const sumTWIA = (num1, num2) => {
        if (!_.isNil(num1) && !_.isNil(num2)) {
            return num1 + num2;
        }

        return null;
    }

    const totalAreaValue = useCallback(() => {
        if (_.get(buildingViewVM, 'construction_TWIA.areaOfExistingStructure_TWIA.value') &&
            _.get(buildingViewVM, 'construction_TWIA.areaOfAddition_TWIA.value')) {
            if (!isTotalAreaEditable) {
                const sumtotalAreaValue = sumTWIA(
                    buildingViewVM.construction_TWIA.areaOfExistingStructure_TWIA.value,
                    buildingViewVM.construction_TWIA.areaOfAddition_TWIA.value);

                _.set(buildingViewVM, 'construction_TWIA.totalArea_TWIA', sumtotalAreaValue)
            }

            updateBuildingViewVM(buildingViewVM);
            updateSubmissionData(buildingViewVM);
        }
    }, [buildingViewVM, isTotalAreaEditable, updateSubmissionData])

    const origConstructionDate = useCallback(() => {
        if (buildingViewVM.construction_TWIA.yearBuilt_TWIA.value) {
            // If Original Construction Date has already been set, only change the year
            const yearBuiltValue = _.get(buildingViewVM, 'construction_TWIA.yearBuilt_TWIA.value')
            const origConstDate = _.get(buildingViewVM, 'construction_TWIA.originalConstructionDate_TWIA.value')
                setDateMismatchValidationMessage([]);
                setYearMismatchValidationMessage([]);
                setFutureYearValidationMessage([]);
            //DE15924
            if(_.isUndefined(yearBuiltValue)){
                if (_.isUndefined(origConstDate)) { //DE15845
                    setDateMismatchValidationMessage([translator(messages.dateMustmatch)]);
                } else if (origConstDate) {
                    _.set(buildingViewVM, 'construction_TWIA.originalConstructionDate_TWIA.value.year', yearBuiltValue)
                } 
            } else {
                // If Original Construction Date has not been set yet, set it to the first day of the year
                _.set(buildingViewVM, 'construction_TWIA.originalConstructionDate_TWIA', {
                    year: yearBuiltValue,
                    month: '00',
                    day: '01'
                });
            }
        }

        updateBuildingViewVM(buildingViewVM);

        // Clear fields that are invisible based on Year Built
        if (!buildingViewVM.construction_TWIA.strucQualifyforHistoric_TWIA.aspects.visible) {
            _.set(buildingViewVM, 'construction_TWIA.strucQualifyforHistoric_TWIA', undefined);

        } else {
            // Default Historic Structures to No
            const strucQualifyforHistoricValue = buildingViewVM.construction_TWIA.strucQualifyforHistoric_TWIA.value === undefined ?
                false : _.get(buildingViewVM, 'construction_TWIA.strucQualifyforHistoric_TWIA.value');

            _.set(buildingViewVM, 'construction_TWIA.strucQualifyforHistoric_TWIA', strucQualifyforHistoricValue)

        }
        // 2024-07-08 - Debra Frum - DE15869 - Feature Testing: TWIA_Commercial Quote - 
        //                                     DTO error prevents Construction Details from being saved
        // To prevent DTO error "This field can not be set but is", clear field hasWPI8CertComplience_TWIA whose
        // visibility or availability is dependent on other fields when the other fields are changed
        _.set(buildingViewVM, 'construction_TWIA.hasWPI8CertComplience_TWIA', undefined);

        updateBuildingViewVM(buildingViewVM);

    }, [buildingViewVM])

    const windRatingValues = useCallback(() => {

        const newValue = _.get(buildingViewVM, 'construction_TWIA.constructionType_TWIA.value')
        let windRatingPCOption;

        const windRating = {

            aspects: {
                availableValues: []
            }
        };

        windRatingPCOption = undefined;

        const windRatingTypeList = viewModelService.productMetadata.get('pc').types.getTypelist('WindRating');

        // DE15970 DE15972 
        if (_.get(buildingViewVM, 'riskItemType_TWIA.value.code') === 'FRBOrOutbldgOrBPP') {
            let { codes } = windRatingTypeList.filters.find((f) => f.name === 'FarmRanchNonFrame');

            if (_.get(newValue, 'code') === 'FIso') {
                codes = windRatingTypeList.filters.find((f) => f.name === 'FarmRanchFrame').codes;
            }

            windRating.aspects.availableValues = codes;
        } else if (_.get(buildingViewVM, 'riskItemType_TWIA.value.code') === 'RBHouseOrBPP') { 
            if (_.get(newValue, 'code') === 'FIso') {
                windRating.aspects.availableValues = windRatingTypeList.filters.find((f) => f.name === 'RoomingBoardingHouseFrame').codes;
            } else {
                if (windRatingPCOption === undefined && windRating.value !== undefined) { 
                    windRatingPCOption = windRatingTypeList.filters.find((f) => f.name === 'RoomingBoardingHouseNonFrame').codes.find((c) => c.code === $scope.windRating.value.code);
                }
                //  As part of DE15972 the logic for handling the 'OC' filter has been removed
                // DE18819
                const ocCode = windRatingTypeList.filters.find((f) => f.name === 'RoomingBoardingHouseNonFrame').codes.find((c) => c.code === 'OC');

                if (windRatingPCOption !== undefined && windRatingPCOption !== ocCode) {
                    windRating.aspects.availableValues = [windRatingPCOption, ocCode];
                } else {
                    windRating.aspects.availableValues = [ocCode];
                }

            }

        } else {
            windRating.aspects.availableValues = windRatingTypeList.getCodesForCategory(newValue);
        }

        if (windRating.aspects.availableValues.length > 0) {
            const windRatingList = windRating.aspects.availableValues.map((code) => {
                return {
                    code: code.code,
                    name: translator({ id: code.name })
                }

            })

            return windRatingList
        }
    }, [buildingViewVM, translator, viewModelService])
    
    const determineFutureDate = useCallback((value) =>{
        const currentDate = new Date();
        const enteredDate = !_.isUndefined(value) ? new Date(value.year, value.month, value.day) : undefined;
        
        if (!_.isUndefined(enteredDate) && ( enteredDate > currentDate)){
            setFutureYearValidationMessage([translator(messages.cannotBeFutureDate)]);
        }
        else {
            setFutureYearValidationMessage([]);
        }
    }, []);
    
    const checkValidDate = useCallback(() => {
        let validationMessages = [];
        //DE15845
        // if (!_.isEmpty(dateMismatchValidationMessage)) {
        //     validationMessages.push(...dateMismatchValidationMessage);
        // }
    
        if (!_.isEmpty(yearMismatchValidationMessage)) {
            validationMessages.push(...yearMismatchValidationMessage);
        }
    
        if (!_.isEmpty(futureYearValidationMessage)) {
            validationMessages.push(...futureYearValidationMessage);
        }

        // DE16164 - Custom Requiredness Message not working on empty form, so do it here.
        if(_.isUndefined(_.get(buildingViewVM, 'construction_TWIA.originalConstructionDate_TWIA.value'))){
            validationMessages.push(...[translator(messages.dateMustmatch)]);
        }

        return validationMessages;
    }, [yearMismatchValidationMessage, futureYearValidationMessage]);

    const writeValue = useCallback(
        (value, path) => {
            if (path === 'construction_TWIA.originalConstructionDate_TWIA') {
                if (!buildingViewVM.construction_TWIA.hasWPI8CertComplience_TWIA.aspects.visible) {
                    _.set(buildingViewVM, 'construction_TWIA.hasWPI8CertComplience_TWIA', undefined);
                }

                setDateMismatchValidationMessage([]);
                setYearMismatchValidationMessage([]);
                setFutureYearValidationMessage([]);
                //DE15845
                if (_.isUndefined(value)) {
                    setDateMismatchValidationMessage([translator(messages.dateMustmatch)]);
                } else if (yearBuilt !== undefined && value !== undefined && value.year !== parseInt(yearBuilt)) {
                    setYearMismatchValidationMessage([translator(messages.yearMustmatch)])
                }
                determineFutureDate(value);
            }

            if (path === 'construction_TWIA.areaOfExistingStructure_TWIA' || path === 'construction_TWIA.areaOfAddition_TWIA') {
                totalAreaValue()
            }

            if (path === 'construction_TWIA.yearBuilt_TWIA') {
                origConstructionDate();
            }

            if (path === 'construction_TWIA.constructionType_TWIA') {
                windRatingValues();
            }

            _.set(buildingViewVM, path, value);
            updateBuildingViewVM(buildingViewVM);
            updateSubmissionData(buildingViewVM);
            refreshData();

        },
        [buildingViewVM, determineFutureDate, origConstructionDate, refreshData, 
            totalAreaValue, translator, updateSubmissionData, windRatingValues, yearBuilt]
    );
    
    const currentLocationCounty = address.county;
    
    function harrisCountyMessage() {
        return (
            <div className={styles.harrisMessage}>
                <span style={{ display: 'flex' }}>
                    <Icon id="icon" icon="gw-info" title="Info" color="#4074ce" />
                    <h5 style={{ paddingLeft: '4px'}}>{'Info: '}</h5>
                    <text style={{ paddingLeft: '6px'}}>{translator(messages.messageLine0)}</text>
                </span>
                <ol style={{ marginBottom: '0rem', marginLeft: '2.2rem'}} start="1">
                    <li>{translator(messages.messageLine1)}</li>
                    <li>{translator(messages.messageLine2)}</li>
                    <li>{translator(messages.messageLine3)}</li>
                </ol>
            </div>
        );
    };

    // US26387 US29240 US29242 US29242
    const isBuildingExistingOnTerm = useCallback(() => {
        if(!_.isUndefined(buildingViewVM)){
            return TWIACPBuildingLocationsHelper.isBuildingExistsOnBasedOn
            (_.get(buildingViewVM, 'publicID.value'), submissionVM.value)
        }
        
        return false;
    }, [buildingViewVM, submissionVM]);

    const overrideProps = {
        '@field': {
            // apply to all fields
            showErrors: !isComponentValid && showErrorsConstruction,
            showOptional: false,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top',
        },
        totalArea_TWIA: {
            readOnly: !isTotalAreaEditable || (isBuildingExistingOnTerm() 
            && !submissionVM.isAddBuilding)
        },
        buildersRiskDetailsTitle: {
            visible: _.get(buildingViewVM, 'coverageForm.value.code') === 'TWCR'
        },
        windRating: {
            readOnly: isBuildingExistingOnTerm() && !submissionVM.isAddBuilding,
            disabled: !_.get(buildingViewVM, 'construction_TWIA.constructionType_TWIA.value'),
            availableValues: _.get(buildingViewVM, 'construction_TWIA.constructionType_TWIA.value') !== undefined ? windRatingValues() : []
        },
        harrisCountyMessage: {
            visible: currentLocationCounty === 'Harris',
            content: harrisCountyMessage()
        },
        originalConstructionDate: {
            validationMessages: checkValidDate(),
            readOnly: isBuildingExistingOnTerm() && !submissionVM.isAddBuilding
        },
        constructionType: {
            onValueChange: constructionChange,
            readOnly: isBuildingExistingOnTerm() && !submissionVM.isAddBuilding
        },
        yearBuilt: {
            readOnly: isBuildingExistingOnTerm() && !submissionVM.isAddBuilding
        },
        antennaSatelliteDish: {
            readOnly: isBuildingExistingOnTerm() && !submissionVM.isAddBuilding
        },
        wallsOpenBy50Percent: {
            readOnly: isBuildingExistingOnTerm() && !submissionVM.isAddBuilding
        },
        structureType: {
            readOnly: isBuildingExistingOnTerm() && !submissionVM.isAddBuilding
        },
        height: {
            readOnly: isBuildingExistingOnTerm() && !submissionVM.isAddBuilding
        },
        structureCovered: {
            readOnly: isBuildingExistingOnTerm() && !submissionVM.isAddBuilding
        },
        numberofStories: {
            readOnly: isBuildingExistingOnTerm() && !submissionVM.isAddBuilding
        },
        groundFloorArea_TWIA: {
            readOnly: isBuildingExistingOnTerm() && !submissionVM.isAddBuilding
        },
        roofType: {
            readOnly: isBuildingExistingOnTerm() && !submissionVM.isAddBuilding
        },
        hasWPI8CertComplience: {
            readOnly: isBuildingExistingOnTerm() && !submissionVM.isAddBuilding
        },
        // Builder's Risk Details
        materialDeliveryDate: {
            readOnly: isBuildingExistingOnTerm() && !submissionVM.isAddBuilding
        },
        constructionStartDate: {
            readOnly: isBuildingExistingOnTerm() && !submissionVM.isAddBuilding
        },
        shouldCoverageInclude: {
            readOnly: isBuildingExistingOnTerm() && !submissionVM.isAddBuilding
        },
        areaofExistingStructure: {
            readOnly: isBuildingExistingOnTerm() && !submissionVM.isAddBuilding
        },
        areaOfAddition: {
            readOnly: isBuildingExistingOnTerm() && !submissionVM.isAddBuilding
        },
    }

    const resolvers = {
        resolveComponentMap: {

        },
        resolveCallbackMap: {
            totalAreaValue,
            windRatingValues,
            origConstructionDate,

        },
        resolveClassNameMap: { wizardStyles, styles },
    };

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            model={buildingViewVM}
            overrideProps={overrideProps}
            onModelChange={updateBuildingViewVM}
            onValueChange={writeValue}
            onValidationChange={setComponentValidation}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        // showErrors={showErrors}
        />
    )
}

export default TWIACPConstructionDetails